/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLeagueTeamsResponsePagination } from './GetLeagueTeamsResponsePagination';
import {
    GetLeagueTeamsResponsePaginationFromJSON,
    GetLeagueTeamsResponsePaginationFromJSONTyped,
    GetLeagueTeamsResponsePaginationToJSON,
    GetLeagueTeamsResponsePaginationToJSONTyped,
} from './GetLeagueTeamsResponsePagination';
import type { LeagueTeam } from './LeagueTeam';
import {
    LeagueTeamFromJSON,
    LeagueTeamFromJSONTyped,
    LeagueTeamToJSON,
    LeagueTeamToJSONTyped,
} from './LeagueTeam';

/**
 * 
 * @export
 * @interface GetLeagueTeamsResponse
 */
export interface GetLeagueTeamsResponse {
    /**
     * 
     * @type {Array<LeagueTeam>}
     * @memberof GetLeagueTeamsResponse
     */
    teams: Array<LeagueTeam>;
    /**
     * 
     * @type {GetLeagueTeamsResponsePagination}
     * @memberof GetLeagueTeamsResponse
     */
    pagination: GetLeagueTeamsResponsePagination;
}

/**
 * Check if a given object implements the GetLeagueTeamsResponse interface.
 */
export function instanceOfGetLeagueTeamsResponse(value: object): value is GetLeagueTeamsResponse {
    if (!('teams' in value) || value['teams'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function GetLeagueTeamsResponseFromJSON(json: any): GetLeagueTeamsResponse {
    return GetLeagueTeamsResponseFromJSONTyped(json, false);
}

export function GetLeagueTeamsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeagueTeamsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teams': ((json['teams'] as Array<any>).map(LeagueTeamFromJSON)),
        'pagination': GetLeagueTeamsResponsePaginationFromJSON(json['pagination']),
    };
}

export function GetLeagueTeamsResponseToJSON(json: any): GetLeagueTeamsResponse {
    return GetLeagueTeamsResponseToJSONTyped(json, false);
}

export function GetLeagueTeamsResponseToJSONTyped(value?: GetLeagueTeamsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teams': ((value['teams'] as Array<any>).map(LeagueTeamToJSON)),
        'pagination': GetLeagueTeamsResponsePaginationToJSON(value['pagination']),
    };
}

